import { root, id } from './upload';

export const upload = {
  ...root,
  id,
};
